import { MdAdd } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { useUpdateUserProfile } from "../api/user";
import { useTranslation } from "react-i18next";
import anonymous from "../../../resources/img/anonyme_pic.png";
import { Formik, Form, FormikHelpers } from "formik";
import { LoadingButton } from "@mui/lab";
import FormFieldInput from "../../../components/Forms/FormFieldInput";
import { ChangeEvent, useEffect, useState } from "react";
import { selectAuthentificated, selectCurrentUser } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import { UserDto } from "../types";

import "./styles.css";
import { useKeycloak } from "@react-keycloak/web";
import { Notifications } from "../../../components/notifications";
import { Button } from "@mui/material";
import { userValidationSchema } from "../validation";
import { dir } from "console";
import { CheckIfExist } from "../../../App";
import PartnerForm from "../../partners/components/PartnersForm";
import { useGetPartner } from "../../partners/api/getPartners";
import { getPartners, PartnerDto } from "../../partners";
import axios from "axios";
import settings from "../../../config/settings";


const User = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("common");
  const isAuthentificated = useSelector(selectAuthentificated); 
  const [profile, setProfile] = useState(anonymous);
  const { keycloak, initialized } = useKeycloak();
  const [user, setUser] = useState({} as UserDto);
  const [partner, setPartner] = useState<PartnerDto | null>(null);
  const currentUser = useSelector(selectCurrentUser);
  // const { data: partner } = useGetPartner("1"); 

  useEffect(() => {
    if(!!isAuthentificated) {
      loadUserProfile();
      loadAvatar();
    } 
  }, [isAuthentificated]);

  const loadUserProfile = async () => {
      let userProfile = await keycloak.loadUserProfile();
      setUser(userProfile as UserDto);
      loadStructure();
  };

  const loadStructure = async () => {
    try {
      let response = await getPartners({
        queryString: `filters=emailAccount==${currentUser.preferred_username}`,
      });
      let structure = response.data;
      
      // Informations sur la structure de l'utilisateur connecté
      if(structure.length > 0) setPartner(structure[0]);
    } catch(e) {
      console.log(e);
    }
  };


  const loadAvatar = () => {
    if(settings.baseProfileUrl) {
      axios.get(settings.baseProfileUrl + currentUser?.preferred_username)
      .then((res) => {
        if(res.config.url){
          setProfile(res.config.url)
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }



  const updateUserProfileApi = useUpdateUserProfile();
  const submitUpdate = (data: UserDto, formikHelpers: FormikHelpers<UserDto>) => {
    let newUser = {
      username: data.username,
      lastName: data.lastName,
      firstName: data.firstName,
      email: data.email
    } as any;

    updateUserProfileApi
      .mutateAsync(newUser)
      .then((response) => {
        formikHelpers.setSubmitting(false);
        Notifications.success("Votre profil a été mis à jour avec succès");
        loadUserProfile();
      })
      .catch((e) => {
        formikHelpers.setSubmitting(false);
        Notifications.error("Une erreur est survenue lors de la mise à jour de votre profil.");
        console.error(e);
      });

  }

  const getFile = (event: ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if(files && files.length > 0) {
      if(target.id == 'profile') setProfile(files[0] as any);
    }
  }
     

  return (
    <>
        <main>
          <section>
              <div id="card-content">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 mt-4" style={{ fontStyle: "italic" }}>
                        { t('account.home') }/<span style={{ fontWeight: "bold" }}>{ t('account.myProfile') }</span>
                        <hr/>
                    </div>
                  </div>
                  
                  <div className="row">
                      <div className="col-md-3">
                          <div className="card card-2 mt-3 w-100"> {/*  mmb-7 ml-auto mr-auto TODO: Tab with user informations */}
                            <div className="card-body">
                                <div className="p-4">
                                  <div className="d-flex flex-column mb-2">
                                    <img src={profile} alt="profile" className="profile-pic" />
                                    <div className="d-flex flex-column mt-4 text-center">
                                      <span className="mb-2 uppercase" style={{ fontSize: "20px", fontWeight: "bold" }}>{ user.username }</span>
                                      <span className="uppercase" style={{ fontSize: "15px" }}>
                                         { user?.attributes?.poste }
                                      </span>
                                    </div>
                                    <div className="">    
                                      
                                    </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div className="col-md-9">
                          <div className="card card-2 mt-3 w-100"> {/* mmb-7 ml-auto mr-auto TODO: Tab with user informations */}
                            <div className="card-body">
                                <div className="p-4">
                                  <div className="mb-2">
                                   
                                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                          <button className="nav-link active" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">{ t('account.tabProfile') }</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                          <button className="nav-link" id="update-tab" data-toggle="tab" data-target="#update" type="button" role="tab" aria-controls="update" aria-selected="false">{ t('account.tabUpdate') }</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                          <button className="nav-link" id="update-structure-tab" data-toggle="tab" data-target="#update-structure" type="button" role="tab" aria-controls="update-structure" aria-selected="false">{ t('account.tabUpdateStruct') }</button>
                                        </li>
                                      </ul>
                                      <div className="tab-content mb-5" id="myTabContent">
                                        <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                          
                                          <div className="mb-5">
                                            <div className="d-flex flex-column">
                                              <div className="row mb-4">
                                                <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.username') } </label>
                                                  <span>{ user.username }</span>
                                                </div>
                                                <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.firstname') } </label>
                                                  <span>{ user.firstName }</span>
                                                </div>
                                                <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.lastname') } </label>
                                                  <span>{ user.lastName }</span>
                                                </div>
                                                <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.email') } </label>
                                                  <span>{ user.email }</span>
                                                </div>
                                                {/* <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.departement') } </label>
                                                  <span>{ user.attributes.departement }</span>
                                                </div>
                                                <div className="col-12 col-md-6  mt-4">
                                                  <label className="form-label mb-2 w-100">{ t('account.poste') } </label>
                                                  <span>{ user.attributes.poste }</span>
                                                </div> */}
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                        { partner && <div className="tab-pane fade" id="update" role="tabpanel" aria-labelledby="update-tab">
                                        
                                          <div>
                                              <Formik
                                                    initialValues={user}
                                                    // validationSchema={userValidationSchema}
                                                    onSubmit={(values, formikHelpers) => {
                                                      // console.log("VALUES ", values);
                                                      submitUpdate(values, formikHelpers);
                                                    }}
                                                    // validateOnChange={false}
                                                    validateOnMount={false}
                                                    // initialStatus={true}
                                                    enableReinitialize={true} // Réinitialise les valeurs et désactive la validation lors du premier rendu
                                                  >
                                                    {({ isValid, dirty, errors, isSubmitting, values, setFieldValue, handleReset }) => {
                                                  
                                                      return (
                                                        <Form>
                                                            <div>
                                                                { isSubmitting && <div className="lds-roller"></div> }
                                                                <div className="d-flex flex-column">
                                                                  <div className="row mb-4">
                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="username" disable={true} errors={errors} setFieldValue={setFieldValue} value={values.username == "" ? user.username : values.username} label={t('account.username')} />
                                                                    </div>
                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="email" disable={true} errors={errors} setFieldValue={setFieldValue} value={values.email == "" ? user.email : values.email} label={t('account.email')}  />
                                                                    </div>
                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="firstName" errors={errors} setFieldValue={setFieldValue} value={values.firstName == "" ? user.firstName : values.firstName} label={t('account.firstname')}  />
                                                                    </div>
                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="lastName" errors={errors} setFieldValue={setFieldValue} value={values.lastName == "" ? user.lastName : values.lastName } label={t('account.lastname')}  />
                                                                    </div>

                                                                    {/* <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="departement" errors={errors} setFieldValue={setFieldValue} value={values.attributes.departement == "" ? user.attributes.departement : values.attributes.departement } label={t('account.departement')}  />
                                                                    </div>
                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="poste" errors={errors} setFieldValue={setFieldValue} value={values.attributes.poste == 0 ? user.attributes.poste : values.attributes.poste} label={t('account.poste')}  />
                                                                    </div> 

                                                                    <div className="col-12 col-md-6">
                                                                      <FormFieldInput name="profile" onChange={getFile}  type="file" label={t('account.picture')} accept="image/*" />
                                                                    </div> */}
                                                                  </div>
                                                                </div> 
                                                            </div>
                                                            <div className="d-flex justify-content-end">
                                                              <LoadingButton 
                                                                type='submit' 
                                                                //disabled={!(isValid && dirty)}
                                                                variant="contained"
                                                                className="px-1"
                                                                children={t('app.save')}
                                                                loading={isSubmitting}
                                                                style={{
                                                                  marginLeft:"10px",
                                                                  color: "#fff",
                                                                  backgroundColor: "#FF7900",
                                                                  width: "100px !important"
                                                                }}
                                                                sx={{
                                                                  "&.MuiButton-root": {
                                                                    textTransform: 'none',
                                                                    height: "32px",
                                                                    width: "100px",
                                                                  },
                                                                  "&.Mui-disabled": {
                                                                    color: "white",
                                                                  }
                                                                }}
                                                              />        
                                                            </div>

                                                          </Form>
                                                        );
                                                      }}
                                                    </Formik>

                                            </div>
                                          </div>
                                        }
                                        { partner && <div className="tab-pane fade" id="update-structure" role="tabpanel" aria-labelledby="update-structure-tab">
                                            <PartnerForm defaultPartner={partner}/>
                                          </div>
                                        }
                                      </div>

                                  </div>
                                </div>
                            </div>
                          </div>
                      </div>

                  </div>
                </div>
              </div>
          </section>
        </main> 
    </>
  );
}
export default User;

